import React from 'react';
import './Hero.css';

const Hero = () => (
  <section className="hero">
    <div className="hero-content">
      <h1>
        World's First API For Live <br />
        Classes, Video Uploads, And <br />
        Class Scheduling.
      </h1>
      <a href="/features"><button className="btn btn-outline-light explore-btn">Explore Options</button></a>
      
    </div>
  </section>
);

export default Hero;
